import React, { type ReactNode } from 'react';
import { AuthProvider } from '../contexts/AuthContext';
import { PrivacyProvider } from '../contexts/PrivacyContext';
import { LanguageProvider } from '../contexts/LanguageContext';

type AppProvidersProps = {
  children: ReactNode;
};

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  return (
    <LanguageProvider>
      <AuthProvider>
        <PrivacyProvider>{children}</PrivacyProvider>
      </AuthProvider>
    </LanguageProvider>
  );
};
